export interface ColumnData{
    id: string;
    title: string;
    key: string;
}

export interface AddReport {
    title: string;
    type: string;
    scheduling: string;
    todate: string;
    fromDate: string;
    customerId: string[];
    associatedCustomerId: string[];
    notificationEmails: string[];
    templateColumn: ColumnData[];
    save: boolean;
    reportCategory: string;
    filterDateRangeName: string;
    invoiceGroupId?: string[];
  }
  
  export interface ReportColumn {
    id: string;
    updatedAt: string;
    createdAt: string;
    title: string;
    key: string;
    isActive: boolean;
  }
  
  export interface CustomerRowDataType {
    id: string;
    name: string;
    customerNumber: string;
    customerLevel: string;
  }
  
  export interface DropwdownValueTypes {
    id: string;
    name: string;
    customerLevel: string;
  }
  
  export interface ColumnType {
    key: string;
    header: string;
    isSortable: boolean;
    className: string;
  }
  
  export interface ReportItem {
    count: number;
    id: string;
    createdOn: string;
    createdAt: string;
    title: string;
    createdBy: string;
    customerName: string;
    customerType: string;
    scheduling: string;
    type: string;
  }
  
  export interface CountryCodeApiResponse {
    success: boolean;
    data: any;
  }

  export const ReportColumns = [
  { key: "count", header: "S.", isSortable: false, className: "count" },
  {
    key: "title",
    header: "Report Title",
    isSortable: true,
    className: "dark",
  },
  {
    key: "customerName",
    header: "Customer Name",
    isSortable: true,
    isHoverable: true,
    className: "dark",
  },
  // {
  //   key: "customerType",
  //   header: "Customer Type",
  //   isSortable: true,
  //   className: "dark",
  // },
  {
    key: "createdOn",
    header: "Created On",
    isSortable: true,
    className: "dark",
  },
  {
    key: "createdBy",
    header: "Created By",
    isSortable: true,
    className: "dark",
  },
  // {
  //   key: "scheduling",
  //   header: "Report Scheduling",
  //   isSortable: true,
  //   className: "dark",
  // },
  {
    key: "type",
    header: "Report Type",
    isSortable: true,
    className: "dark",
  },
  {
    key: "reportCat",
    header: "Report Category",
    isSortable: true,
    className: "dark",
  },
  {
    key: "reportDateType",
    header: "Report Date Type",
    isSortable: true,
    className: "dark",
  },
];
export const tableConfig = {
    delete: {
      apiUrl: "/report",
      urlID: "id",
      successMessage: "Report deleted successfully!",
      heading: "Delete Report!",
      para: "delete",
      rowName: "title",
      secondRowName: "",
    },
  };